import http from '../../helper/http';

let languages = {};

export default {
  async getLanguage () {
    let lang = await http.get(`/api/languages`);
    languages = lang.data.data;
    return languages;
  },
};
